import { InitiativeCreationStep } from '@app/pages/dashboard/initiative/shared/workflow'
import { NotificationFrequency } from '@schema/user'
import {
  InitiativeUserRole,
  NumberOfHomes,
  OwnershipMode,
  RentSegment,
} from 'schema/initiative'
import { PlotApplicationStatus } from 'schema/plot'
import { PhaseType } from '@schema/phase'

type Translation<T extends string | number | symbol> = {
  [K in T]: string
}

export const phaseTranslations: Translation<PhaseType> = {
  idea: 'Ideefase',
  location: 'Locatiefase',
  design: 'Ontwerpfase',
  construction: 'Bouwfase',
  living: 'Woonfase',
} as const

export const plotApplicationStatusesTranslations: Translation<PlotApplicationStatus> =
  {
    applicationOpen: 'Inschrijving open',
    applicationClosed: 'Inschrijving gesloten',
    inPreparation: 'In voorbereiding',
  } as const

export const initiativeUserRoleTranslation: Translation<InitiativeUserRole> = {
  owner: 'Initiatiefnemer',
  admin: 'Beheerder',
  member: 'Deelnemer',
  applicant: 'Aanvrager',
  follower: 'Volger',
} as const

// Note: AgeCategory, HousingTypePreference, OwnershipPreference are now schema entities
// and no longer enum types. These translations are kept for reference but not type-safe.

export const notificationFrequencyTranslation: Translation<NotificationFrequency> =
  {
    weekly: 'Wekelijks',
    fortnightly: 'Tweewekelijks',
    monthly: 'Maandelijks',
    never: 'Nooit',
  } as const

export const initiativePhaseNameTranslation: Translation<PhaseType> = {
  idea: 'Ideefase',
  location: 'Locatiefase',
  design: 'Ontwerpfase',
  construction: 'Bouwfase',
  living: 'Woonfase',
} as const

export const initiativePhaseDescriptionTranslation: Translation<PhaseType> = {
  idea: 'Je hebt een eerste idee dat je met anderen wil delen.',
  location:
    'Je zoekt samen met je groep naar een locatie voor jullie initiatief.',
  design:
    'Je werkt samen met je groep aan het ontwerp van jullie droomwoningen.',
  construction: 'De bouw is gestart en jouw woondroom wordt gerealiseerd.',
  living:
    'Je woont in een gerealiseerd zelfbouwproject en wil anderen inspireren.',
} as const

export const initiativeCreationStepTitleTranslation: Translation<InitiativeCreationStep> =
  {
    phaseSelection: 'In welke fase zit jouw initiatief?',
    livingVision: 'Woonvisie',
    images: 'Afbeeldingen',
    initiativeDetails: 'Initiatief details',
    livingTogether: 'Met wie wil je wonen?',
    livingAmenities: 'Woonamenities',
    location: 'Waar wil je wonen?',
    contact: 'Contact',
    finish: 'Je initiatief is online!',
  } as const

export const initiativeCreationStepDescriptionTranslation: Translation<InitiativeCreationStep> =
  {
    phaseSelection: null,
    livingVision:
      'Beschrijf je idee zo concreet mogelijk. Het helpt bij de matching.',
    images:
      'Goede beelden maken je initiatief opvallend. Zorg dat je het recht hebt om de afbeeldingen te gebruiken.',
    initiativeDetails: null,
    livingTogether: null,
    livingAmenities: null,
    location: null,
    contact: null,
    finish:
      'Gefeliciteerd! Je initiatief is nu zichtbaar op CrowdBuilding. Zet een volgende stap om je woondroom werkelijkheid te maken.',
  } as const

export const humberOfHomesTranslation: Translation<NumberOfHomes> = {
  from2To5: '2-5',
  from6To10: '6-10',
  from11to15: '11-15',
  from16to30: '16-30',
  from31to50: '31-50',
  from51to80: '51-80',
  from81to100: '81-100',
  moreThan100: '100+',
} as const

export const ownershipModeTranslation: Translation<OwnershipMode> = {
  buy: 'Koop',
  rent: 'Huur',
  mix: 'Mix',
  dontKnow: 'Weet ik nog niet',
} as const

export const rentSegmentTranslation: Translation<RentSegment> = {
  social: 'Sociaal',
  middle: 'Midden',
  freeSector: 'Vrije sector',
} as const
